import {
  SET_IS_CJ_REDIRECT,
  SET_REDIRECT_SUPPRESSED,
  SET_REDIRECT_TIMEOUT,
  SHOW_MISSING_TRACKING_PARAMS,
  SUPRESS_SPLASH_PAGE,
} from '../actions';

const defaultState = {
  suppressed: false,
  timeout: null,
  missingTrackingParams: [],
  isCJRedirect: false,
  skipSplashPage: false,
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case SHOW_MISSING_TRACKING_PARAMS:
      return {
        ...state,
        missingTrackingParams: action.missingTrackingParams,
      };
    case SET_REDIRECT_SUPPRESSED:
      return {
        ...state,
        suppressed: action.suppressed,
      };
    case SET_REDIRECT_TIMEOUT:
      return {
        ...state,
        timeout: action.timeout,
      };
    case SET_IS_CJ_REDIRECT:
      return {
        ...state,
        isCJRedirect: action.isCJRedirect,
      };
    case SUPRESS_SPLASH_PAGE:
      return {
        ...state,
        skipSplashPage: true,
      };
    default:
      return state;
  }
};
